/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line func-names
(function (angular) {
  angular
    .module("app")
    .controller("notificationsController", notificationsController);

  notificationsController.$inject = ["notificationsApi", "$scope"];

  function notificationsController(notificationsApi, $scope) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.limit = 20;
    vm.markAsRead = markAsRead;

    function getNotifications() {
      // Handle the api call response - saves the response to notifications variable
      const handleNotificationsResponse = (response) => {
        vm.notifications = response.data;
      };

      notificationsApi.get(
        {
          id: null,
          type: null,
          notifiable_id: null,
          created_at_from: null,
          created_at_to: null,
          read: null,
          sort: "created_at",
          order: "desc",
        },
        handleNotificationsResponse,
      );
    }

    function markAsRead(notification) {
      if (notification.read_at === null) {
        notificationsApi.post({
          id: [notification.id],
        });

        getNotifications();
      }
    }

    getNotifications();

    $scope.loadMore = function () {
      var increamented = vm.limit + 10;
      vm.limit =
        increamented > vm.notifications.length
          ? vm.notifications.length
          : increamented;
    };
  }
})(angular);
